/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import * as b64$ from "../lib/base64.js";

/**
 * 包含表情包文字内容的JSON对象。至少需要提供上方或下方文字之一。
 */
export type PostImageSpeechlessRequest = {
  top_text?: string | undefined;
  bottom_text?: string | undefined;
};

export const PostImageSpeechlessRequest$zodSchema: z.ZodType<
  PostImageSpeechlessRequest
> = z.object({
  bottom_text: z.string().optional(),
  top_text: z.string().optional(),
}).describe("包含表情包文字内容的JSON对象。至少需要提供上方或下方文字之一。");

/**
 * 服务器内部错误。在生成表情包图片过程中发生错误。
 */
export type PostImageSpeechlessInternalServerErrorResponseBody = {
  error?: string | undefined;
};

export const PostImageSpeechlessInternalServerErrorResponseBody$zodSchema:
  z.ZodType<PostImageSpeechlessInternalServerErrorResponseBody> = z.object({
    error: z.string().optional(),
  }).describe("服务器内部错误。在生成表情包图片过程中发生错误。");

/**
 * 请求参数错误。必须提供 'top_text' 或 'bottom_text' 至少其中之一。
 */
export type PostImageSpeechlessBadRequestResponseBody = {
  error?: string | undefined;
};

export const PostImageSpeechlessBadRequestResponseBody$zodSchema: z.ZodType<
  PostImageSpeechlessBadRequestResponseBody
> = z.object({
  error: z.string().optional(),
}).describe(
  "请求参数错误。必须提供 'top_text' 或 'bottom_text' 至少其中之一。",
);

export type PostImageSpeechlessResponse =
  | Uint8Array
  | string
  | PostImageSpeechlessBadRequestResponseBody
  | PostImageSpeechlessInternalServerErrorResponseBody;

export const PostImageSpeechlessResponse$zodSchema: z.ZodType<
  PostImageSpeechlessResponse
> = z.union([
  z.string().describe("Base64-encoded binary content").transform(
    b64$.bytesFromBase64,
  ),
  z.lazy(() => PostImageSpeechlessBadRequestResponseBody$zodSchema),
  z.lazy(() => PostImageSpeechlessInternalServerErrorResponseBody$zodSchema),
]);
